import { render, staticRenderFns } from "./rewardPage.vue?vue&type=template&id=b5f35b3a&scoped=true&"
import script from "./rewardPage.vue?vue&type=script&lang=js&"
export * from "./rewardPage.vue?vue&type=script&lang=js&"
import style0 from "./rewardPage.vue?vue&type=style&index=0&id=b5f35b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f35b3a",
  null
  
)

export default component.exports